import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  BaseDocLineDto,
  CustomerCreditNoteDto,
  CustomerCreditNoteService,
  CustomerReturnNoteService,
  CustomerReturnNoteToCreditNoteDto,
} from '@digiwall/goliath-documents/proxy';
import { DialogBoxComponent } from '@digiwall/ui-kit';
import { ReturnNoteToCreditNoteGridComponent } from './return-note-to-credit-note-grid/return-note-to-credit-note-grid.component';
import { CustomerCreditNotePreviewGridComponent } from './customer-credit-note-preview-grid/customer-credit-note-preview-grid.component';
import { AsyncPipe } from '@angular/common';
import { OdysseyOffcanvas } from '@digiwall/core';

@Component({
  selector: 'document-customer-credit-note-creation-dialog',
  templateUrl: './customer-credit-note-creation-dialog.component.html',
  imports: [
    DialogBoxComponent,
    ReturnNoteToCreditNoteGridComponent,
    CustomerCreditNotePreviewGridComponent,
    AsyncPipe,
  ],
})
export class CustomerCreditNoteCreationDialogComponent implements OnInit {
  @Input() returnNoteId: string;
  @Output() customerCreditNoteCreated = new EventEmitter<CustomerCreditNoteDto>();

  returnNotes$: Observable<CustomerReturnNoteToCreditNoteDto[]>;

  selectedReturnNotes$ = new BehaviorSubject<CustomerReturnNoteToCreditNoteDto[]>([]);

  previewCreditNoteLines$ = new BehaviorSubject<BaseDocLineDto[]>([]);

  offCanvaService = inject(OdysseyOffcanvas);

  constructor(
    private returnNoteService: CustomerReturnNoteService,
    private customerCreditNoteService: CustomerCreditNoteService,
  ) {
    this.selectedReturnNotes$.subscribe(selectedReturnNotes => {
      this.returnNoteService
        .customerCreditNotePreview(
          selectedReturnNotes.map(selectedReturnNote => selectedReturnNote.id),
        )
        .subscribe(previewCreditNoteLines =>
          this.previewCreditNoteLines$.next(previewCreditNoteLines),
        );
    });
  }

  ngOnInit() {
    this.returnNotes$ = this.returnNoteService.returnNotesToCreditNote(this.returnNoteId);
  }

  returnNoteSelectionChange(event) {
    this.selectedReturnNotes$.next(event);
  }

  save() {
    const selectedReturnNoteIds = this.selectedReturnNotes$.value.map(returnNote => returnNote.id);

    this.customerCreditNoteService
      .createFromReturnNotes(selectedReturnNoteIds)
      .subscribe(response => {
        if (response) {
          this.customerCreditNoteCreated.emit(response);
          this.offCanvaService.dismiss();
        }
      });
  }
}
